import React from 'react';
import { useDispatch } from 'react-redux';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { processRbiIssueLoyaltyPointsAndRefund } from '../../../../../actions/tools/RBIActions';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';

const DTRBIIssueLoyaltyPointsAndRefundThenSendMacroNode = () => {
  const dispatch = useDispatch();

  const handleNextButtonClick = async () => await dispatch(processRbiIssueLoyaltyPointsAndRefund());

  return (
    <DTCopyTextSendMacroView
      buttonText={'ISSUE POINTS & REFUND'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={true}
      popupConfirmationText={
        'You are about to issue loyalty points, process a refund and copy the response to the text box'
      }
      customErrorMessage={'Loyalty points issuing request has failed. Please try again later.'}
    />
  );
};

export default withConfirmation(DTRBIIssueLoyaltyPointsAndRefundThenSendMacroNode);
